import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ChangePasswordModal from '../components/ChangePasswordModal';

/**
 * Tela bloqueante exibida no primeiro acesso (ou após reset por admin),
 * quando `user.must_change_password === true`. Reaproveita o
 * ChangePasswordModal em modo `forced` — sem botão de cancelar — para
 * forçar a troca antes de liberar o sistema.
 */
function TrocarSenhaObrigatoria() {
  const { user } = useAuth();
  const { darkMode } = useTheme();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.must_change_password) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-[#0F172A]' : 'bg-gray-100'}`}>
      <ChangePasswordModal
        isOpen
        forced
        onSuccess={() => {
          window.location.href = '/dashboard';
        }}
      />
    </div>
  );
}

export default TrocarSenhaObrigatoria;
